import { dataChevronUp } from 'dls-icons-data'
import { createIcon } from '../common'

const IconChevronUp = /*#__PURE__*/createIcon(dataChevronUp)
export default IconChevronUp
